<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="modal-lg" data-testid="certificate-purchase-modal">
    <div class="modal-header">
        <div class="modal-wizard-label">
            <div class="modal-wizard-title">
                Datos de Facturación
            </div>
            <div class="modal-wizard-desc">
                Complete los campos requeridos para generar su factura por esta compra.
            </div>
        </div>
    </div>
    <form [formGroup]="certificadoForm" (ngSubmit)="onSubmit()" class="formularioCertificado">
        <div class="modal-body " tabindex="-1" ngbAutofocus>
            <div class="alert alert-info border-0 mb-3" *ngIf="mode !== 'generar'" style="background: #e8f4fd; border-left: 4px solid #1b8bee !important; border-radius: 6px;">
                <div class="d-flex align-items-start">
                    <i class="fa fa-info-circle mr-2 mt-1" style="color: #1b8bee; font-size: 1.1rem; flex-shrink: 0;"></i>
                    <div>
                        <strong style="color: #1b5f99;">Importante antes de {{ mode === 'renovar' ? 'renovar' : 'comprar' }}</strong>
                        <ul class="mb-0 mt-1 pl-3" style="color: #374151;">
                            <li>Esta compra corresponde al pago de un nuevo certificado digital.</li>
                            <li>Los datos solicitados en este formulario son <strong>datos de facturación</strong>, no del certificado.</li>
                            <li>Una vez realizado el pago, enviaremos al correo indicado la factura y las instrucciones para generar el certificado digital.</li>
                            <li><strong>En esta etapa no se solicita la contraseña del certificado.</strong></li>
                        </ul>
                        <p class="mb-0 mt-2" style="color: #374151; font-size: 0.875rem;">
                            Para más información sobre la <strong>Garantía de Recuperación</strong>, pase el mouse por el ícono
                            <i class="fa fa-question-circle text-primary ml-1"></i> junto al campo correspondiente.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" *ngIf="mode !== 'generar'">
                    <div class="form-group">
                        <label style="font-weight: 600; color: #333;"><b>Datos para emisión de la factura:</b></label>
                        <ng-select
                            [items]="empresasFacturacion"
                            bindLabel="razonSocial"
                            [clearable]="false"
                            [searchable]="true"
                            [formControl]="empresaFacturacionCtrl"
                            [loading]="cargandoEmpresasFacturacion"
                            [disabled]="usarOtrosDatosFacturacion || cargandoEmpresasFacturacion || !empresasFacturacion.length"
                            placeholder="Seleccione una empresa">
                        </ng-select>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="mode !== 'generar'">
                    <div class="form-check mb-3">
                        <input
                            #chkOtrosDatos
                            class="form-check-input"
                            type="checkbox"
                            id="chkOtrosDatosFacturacion"
                            [checked]="usarOtrosDatosFacturacion"
                            (change)="onToggleOtrosDatosFacturacion(chkOtrosDatos.checked)"
                        />
                        <label class="form-check-label" for="chkOtrosDatosFacturacion">
                            ¿Deseas ingresar otros datos de facturación?
                        </label>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="rut">Rut <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input type="text" id="rut" formControlName="rut" class="form-control" placeholder="12.345.678-9"
                                    maxlength="12" appFormatRut
                                    (blur)="buscaCliente($event.target.value)" required/>
                            <div class="input-group-append" *ngIf="buscandoDatos">
                                <span class="input-group-text bg-warning">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </span>
                            </div>
                            <div class="input-group-append" *ngIf="!existe && !buscandoDatos && certificadoForm.get('rut').valid">
                                <span class="input-group-text bg-success text-white">
                                <i class="fa fa-check"></i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="certificadoForm.get('rut').touched && certificadoForm.get('rut').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('rut').errors?.required">Campo requerido</div>
                            <div *ngIf="certificadoForm.get('rut').hasError('VerificacionRutValidator')">Rut inválido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="correo">Correo<span class="text-danger">*</span></label>
                        <input type="email" id="correo" formControlName="correo" class="form-control" placeholder="Ingrese el correo" required />
                        <div *ngIf="certificadoForm.get('correo').touched && certificadoForm.get('correo').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('correo').errors?.required">Campo requerido</div>
                            <div *ngIf="certificadoForm.get('correo').errors?.email">Correo inválido</div>
                            <div *ngIf="certificadoForm.get('correo').errors?.placeholderEmail">Debes ingresar un correo válido; no se permite usar sincorreo@sincorreo.cl.</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="nombreEmpresa">Razón social <span class="text-danger">*</span></label>
                        <input type="text" id="nombreEmpresa" formControlName="nombreEmpresa" class="form-control" placeholder="Ingrese la Razón social" required />
                        <div *ngIf="certificadoForm.get('nombreEmpresa').touched && certificadoForm.get('nombreEmpresa').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('nombreEmpresa').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="comuna">Comuna <span class="text-danger">*</span></label>
                        <ng-select
                            id="comuna"
                            formControlName="comuna"
                            [items]="comunas"
                            placeholder="Seleccione una comuna"
                            [clearable]="false"
                            [ngClass]="{'is-invalid': certificadoForm.get('comuna')!.invalid && (certificadoForm.touched || certificadoForm.dirty)}">
                        </ng-select>
                        <div *ngIf="certificadoForm.get('comuna').touched && certificadoForm.get('comuna').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('comuna').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="direccion">Dirección <span class="text-danger">*</span></label>
                        <input type="text" id="direccion" formControlName="direccion" class="form-control" placeholder="Ingrese la dirección" required />
                        <div *ngIf="certificadoForm.get('direccion').touched && certificadoForm.get('direccion').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('direccion').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="giroEmpresa">Giro<span class="text-danger">*</span></label>
                        <input type="text" id="giroEmpresa" formControlName="giroEmpresa" class="form-control" placeholder="Ingrese el giro de la empresa" required />
                        <div *ngIf="certificadoForm.get('giroEmpresa').touched && certificadoForm.get('giroEmpresa').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('giroEmpresa').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
               <div class="col-md-3">
                    <div class="form-group">
                        <label for="telefonoContacto">Teléfono</label>
                        <div class="input-group input-group-telefono">
                            <div class="input-group-append">
                                <span class="input-group-text">+56</span>
                            </div>
                            <input
                                type="number"
                                id="telefonoContacto"
                                formControlName="telefonoContacto"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                maxlength="10"
                                min="1"
                                placeholder="962212767"
                                class="form-control telefono"
                            />
                        </div>
                        <span class="form-text text-muted text-telefono">Cod. País + Teléfono</span>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="duracion">Duración certificado <span class="text-danger">*</span></label>
                        <ng-container *ngIf="mode !== 'generar'; else txtPeriodo">
                            <ng-select
                              [items]="periodos"
                              bindLabel="label"
                              bindValue="value"
                              formControlName="duracion"
                              placeholder="Selecciona la duración del certificado"
                              [clearable]="false"
                              [ngClass]="{'is-invalid': certificadoForm.get('duracion')!.invalid && (certificadoForm.touched || certificadoForm.dirty)}">
                            </ng-select>
                        </ng-container>
                        <ng-template #txtPeriodo>
                        <input id="duracion" type="text" class="form-control" formControlName="duracion" [disabled]="mode === 'generar'"  />
                        </ng-template>
                    </div>
                </div>
                <div class="col-md-6 mt-10">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="chkGarantia" formControlName="garantia"  [disabled]="mode === 'generar'" />
                        <label class="form-check-label" for="chkGarantia">
                            Incluir Garantía de Recuperación
                        </label>
                        <i class="fa fa-question-circle ml-1 text-primary" [ngbTooltip]="tooltipContent" container="body"></i>
                    </div>
                </div>
                <div class="table-responsive col-md-12" *ngIf="mode !== 'generar'">
                    <table *ngIf="!loading" class="table table-sm  table-bordered">
                        <thead class="thead-light">
                            <tr>
                                <th>Duración</th>
                                <th class="text-center">Precio Base</th>
                                <th class="text-center">Garantía de Recuperación</th>
                                <th class="text-center">Total sin Garantía + IVA</th>
                                <th class="text-center">Total con Garantía + IVA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let periodo of tablaPrecios" 
                                    [ngClass]="{'table-primary': certificadoForm.get('duracion')?.value === periodo.duracion}">
                                <td>
                                    {{ periodo.duracion }} Año{{ periodo.duracion > 1 ? 's' : '' }}
                                    <span *ngIf="certificadoForm.get('duracion')?.value === periodo.duracion" 
                                        class="badge badge-success ml-2">Seleccionado</span>
                                </td>
                                <td class="text-center">$ {{ periodo.precioCertificado  | number:'1.0-0':'es-CL' }}</td>
                                <td class="text-center">$ {{ periodo.precioGarantia  | number:'1.0-0':'es-CL' }}</td>
                                <td class="text-center">
                                    <strong>$ {{ periodo.precioCertificado  * 1.19 | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>$ {{ (periodo.precioCertificado  + periodo.precioGarantia) * 1.19 | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="certificadoForm.get('duracion')?.value && periodoSel">
                            <tr class="table-secondary">
                                <td colspan="4" class="text-right"><strong>Precio total:</strong></td>
                                <td class="text-center">
                                    <strong class="text-primary" data-testid="certificate-purchase-total">$ {{ total | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="border rounded p-3 mt-2" *ngIf="certificadoForm.get('duracion')?.value">
                        <app-saldo-favor-bloque
                            [total]="total"
                            [maximoElegible]="preciobase + precioGarantia"
                            [permitirTitularSinPlan]="true"
                            (seleccionChange)="actualizarSaldoFavor($event)">
                        </app-saldo-favor-bloque>
                        <div class="d-flex justify-content-between py-1">
                            <strong>Neto a pagar:</strong>
                            <span>$ {{ netoPagarConSaldo | number:'1.0-0':'es-CL' }}</span>
                        </div>
                        <div class="d-flex justify-content-between py-1">
                            <strong>IVA:</strong>
                            <span>$ {{ ivaPagarConSaldo | number:'1.0-0':'es-CL' }}</span>
                        </div>
                        <div class="d-flex justify-content-between py-1">
                            <strong>Total a pagar:</strong>
                            <strong data-testid="certificate-purchase-payable-total">$ {{ totalPagarConSaldo | number:'1.0-0':'es-CL' }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer d-flex align-items-center p-3">
            <div class="text-muted mr-auto col-md-8" style="font-size: 0.85rem;">
                <i class="fa fa-envelope mr-1"></i> Las instrucciones para generar su certificado llegarán al correo indicado.
            </div>
            <div>
                <button class="btn btn-primary mr-2" data-testid="certificate-purchase-submit"
                    type="submit"
                    [disabled]="certificadoForm.invalid">
                    {{ mode==='renovar' ? 'Renovar' : 'Comprar' }}
                </button>
                <button type="button" class="btn btn-secondary" (click)="active.dismiss()">Cancelar</button>
            </div>
        </div>
    </form>
</div>

<ng-template #tooltipContent>
	<div class="tooltip-content">
		<p class="mb-1"><strong>Garantía de Recuperación</strong></p>
		<ul class="pl-3 mb-0" style="font-size: 0.85rem;">
			<li>Si contrataste la garantía, podrás volver a descargar tu certificado desde el panel las veces que necesites, sin costo adicional.</li>
			<li>Si no contrataste garantía y perdiste el archivo .pfx, podrás solicitar una reposición pagando el valor correspondiente según la duración del certificado.</li>
			<li>La reposición no modifica los datos originales del certificado ni permite cambiar la contraseña.</li>
		</ul>
	</div>
</ng-template>
